import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  align-item: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 100%;
`;

export const SelectWrapper = styled.div`
  margin: 0px auto 24px;
  width: 400px;
`;

export const ButtonWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  min-width: 100%;
`;

export const Description = styled.p`
  ${({ theme }) => css`
    align-items: center;
    color: ${theme.v2.colors.neutral.lowPure};
    display: flex;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    jusftify-content: center;
    margin: 16px auto 20px;
  `};
`;

export const AlertWrapper = styled.div`
  align-items: center;
  display: inline-flex;
  justify-content: center;
  margin: 0 24px 24px;

  > div { 
    align-items: center;
    min-width: 100%;
  }
`;
